import { useState, useEffect } from "react";

import API from "utils/api";
import { useUser } from "utils/hooks";
import { filtersToQueryParams } from "utils/misc";

export default function useWarnings(userId, filters = {}) {
  const { token } = useUser();
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchWarnings() {
      setLoading(true);

      const { response, data } = await API.fetchWarnings(token, userId, filtersToQueryParams(filters));

      if (response.ok) {
        setResult(data);
      }

      setLoading(false);
    }

    if (userId) {
      fetchWarnings();
    }
  }, [userId, Object.values(filters).join("__")]);

  return {
    loading,
    warnings: result?.results ?? [],
    count: result?.count ?? 0,
    limit: result?.limit ?? 0,
    page: result?.page ?? 0,
  };
}
